import React, { forwardRef } from 'react';

import Alert, { AlertProps } from '@mui/material/Alert';
import { alpha, useTheme } from '@mui/material/styles';

import { UiAlpha } from '../../../styles/ui-alpha';

export type IAppAlertProps = AlertProps;

const AppAlert = forwardRef<HTMLDivElement, IAppAlertProps>(function AppAlert(
  { severity = 'error', sx, ...rest },
  ref,
) {
  const theme = useTheme();
  const paletteKey = severity as 'error' | 'warning' | 'info' | 'success';
  const main = theme.palette[paletteKey].main;

  return (
    <Alert
      ref={ref}
      severity={severity}
      {...rest}
      sx={[
        {
          fontSize: '1rem',
          lineHeight: 1.5,
          borderRadius: '10px',
          border: `1px solid ${main}`,
          backgroundColor: alpha(main, UiAlpha.Subtle),
          boxShadow: 'none',
          color: theme.palette.text.primary,
          '& .MuiAlert-message': {
            fontSize: '1rem',
            width: '100%',
          },
          '& .MuiAlert-icon': {
            color: main,
            alignItems: 'center',
          },
        },
        ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
      ]}
    />
  );
});

AppAlert.displayName = 'AppAlert';

export default AppAlert;
